<div class="container-full" style="margin-top:10px;">
    <div class="ace-heading-banner">
        <div style="padding-top:18px;">
            <span class="ace-heading-text-level-1" style="margin-left:25px;color:white;">GB Line Item Customization</span>
         </div>
    </div>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
        <mat-card-header>
           
        </mat-card-header>    
        <mat-card-content>
            <div class="row">
            <div class="col-6">
                <div *ngIf="allLotsActiveAndDisabledList.length === 0" style="margin-top:30px;">
                    <div class="row">
                        <div class="col-1">
                        <mat-spinner [diameter]="30" ></mat-spinner>
                        </div>
                        <div class="col-8">
                        <span style="font-size:14px;font-weight: bold;margin-top:10px">Loading All Lots...</span>
                        </div>
                    </div>
                </div>
            </div>
          
            <div  *ngIf="allLotsActiveAndDisabledList.length > 0">
            <div class="row" style="width:100%;">
                <div class="col-6">
                    <mat-form-field appearance="fill" style="width:100%;">
                        <mat-label>All Lots (including enabled for GB Line Item Customization)</mat-label>
                        <mat-select style="width:100%" [typeaheadDebounceInterval]="500"  (selectionChange)="OnLotNumberChange($event.value)">
                        <mat-option value="">Select Lot</mat-option>
                        <mat-option *ngFor="let lot of allLotsActiveAndDisabledList" [value]="lot.lotNumber" >
                            {{lot.lotNumber}}-{{lot.location}}
                        </mat-option>
                        </mat-select>
                        <mat-error>
                            Lot Number is <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <div *ngIf="selectedLotSetCustomizationOn == false && selectedLotNumber != ''">
                        <span>Line Item Customization is <strong>Off</strong></span><br />
                        <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:0px;" (click)="onUpdateLotForInvoiceLineDescriptionCustomization()">Turn on Line Item Customization</button>
                    </div>
                    <div *ngIf="selectedLotSetCustomizationOn == true  && selectedLotNumber != ''">
                        <span>Line Item Customization is <strong>On</strong></span><br />
                        <!-- <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:0px;" (click)="OnUpdateSpaceDisableSetting(false)">Turn off Line Item Customization</button> -->
                    </div>
                    
                </div>    
                </div>
                
                </div>
            </div>

            <div  *ngIf="lotGbInvoiceLineDescriptionStatusList.length == 0">
                <span>There are no lots that are Line Item Customization Enabled</span>

            </div>

            <div  *ngIf="lotGbInvoiceLineDescriptionStatusList.length > 0">
                <span style="font-size:16px;font-weight: bold;margin-bottom:20px;">Line Item Customization Enabled List Lots</span>

                <igx-grid #gridGbEnabledCustomDescription [data]="lotGbInvoiceLineDescriptionStatusList" [width]="'99%'" [height]="'520px'" [autoGenerate]="false" style=margin-left:0px;margin-top:20px;
               [primaryKey]="'lotNumber'">

             
              <igx-column [field]="'lotNumber'"  header="Lot Number" [dataType]="'string'" [sortable]="false"    [movable]="false" [resizable]="true" [groupable]="false" width="200px"></igx-column>
              <igx-column [field]="'isCustomizable'" header="Enabled for Description Customization"  [dataType]="'boolean'" [sortable]="false"    [movable]="false" [resizable]="true" [groupable]="false" width="300px" [hidden]="false"></igx-column>

              <igx-column [field]="'lotNumber'"  header="Turn Off" [dataType]="'string'" [sortable]="false"    [movable]="false" [resizable]="true" [groupable]="false" width="200px">
                <ng-template igxCell let-cell="cell">
                    <div class="cell__inner">
                            <button mat-icon-button class="mt-0 ml-2" 
                            (click)="UpdateInvoiceDescriptionCustomizationToFalse(cell.value, false)" 
                            matTooltip="Clicking this sets this lot's Line Item Customization to Off" >
                            <mat-icon style="margin-left:5px;color:black" >delete</mat-icon>
                        </button>
                    </div>
                </ng-template>
               </igx-column>
              
              </igx-grid>
            </div>
        </mat-card-content>
        <mat-card-actions style="margin-top:20px;">
            
      </mat-card-actions>
  
    </mat-card>                                                                             

    
    <!-- </div> -->


</div>



